import React, { useRef, useState, forwardRef, useImperativeHandle } from 'react';
import { uploadFiles } from 'qwanyx';

export const S3FileUploader = forwardRef(({ onUpload, onError, folderPath = "root", accept, multiple = true }, ref) => {
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const fileInputRef = useRef(null);

  useImperativeHandle(ref, () => ({
    click: () => {
      fileInputRef.current?.click();
    }
  }));

  const handleFileUpload = async (event) => {
    const files = event.target.files;
    if (!files.length) return;

    setIsLoading(true);
    setProgress(0);

    try {
      const filesToUpload = Array.from(files).map(file => {
        const fullFilePath = `${folderPath}/${file.name}`;
        return {
          file,
          key: fullFilePath
        };
      });

      // Reset the file input value so the same file can be uploaded again if needed
      event.target.value = '';
      
      const results = await uploadFiles(filesToUpload);
      
      // Extract just the file names for the callback
      const fileNames = results.successful.map(path => {
        // Extract just the filename from the full path
        const parts = path.split('/');
        return parts[parts.length - 1];
      });
      
      onUpload(fileNames.join(','));
      setProgress(100);
      
    } catch (error) {
      console.error('Error during file upload:', error);
      
      // If we have partial results, we can still report the successful uploads
      if (error.results && error.results.successful.length > 0) {
        const fileNames = error.results.successful.map(path => {
          const parts = path.split('/');
          return parts[parts.length - 1];
        });
        
        onUpload(fileNames.join(','));
      }
      
      // Report the errors if the callback exists
      if (onError && error.results) {
        onError(error.results.failed);
      } else if (onError) {
        onError([{ error: error.message }]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        onChange={handleFileUpload}
        accept={accept}
        disabled={isLoading}
        style={{ display: 'none' }}
        {...(multiple ? { multiple: true } : {})}
      />
      {isLoading && progress > 0 && progress < 100 && (
        <div className="upload-progress">
          Uploading: {progress}%
        </div>
      )}
    </>
  );
});